module.exports = __webpack_public_path__ + "static/media/certificate.4d403d7b.png";